import {
  useQuery,
  QueryConfigType,
  UseQueryResult,
  ExtractFnReturnType,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiMembersTodaysInsightPostsIndexRequestType,
  ApiMembersTodaysInsightPostsIndexResponseType,
} from "~/domains";

type RequestDataType = {
  params: ApiMembersTodaysInsightPostsIndexRequestType;
};

const request = async ({
  params,
}: RequestDataType): Promise<ApiMembersTodaysInsightPostsIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiMembersTodaysInsightPostsIndexResponseType>(
      "/api/members/todays_insight_posts",
      params,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params: ApiMembersTodaysInsightPostsIndexRequestType;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisMembersTodaysInsightPostsIndex = ({
  params,
  config = {},
}: PropsType): UseQueryResult<ApiMembersTodaysInsightPostsIndexResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisMembersTodaysInsightPostsIndex", params],
    queryFn: () => request({ params }),
  });
};
